import { IDateInfo } from "@/domain/entities/book";
import {
  IBookRequest,
  IBookRequestLineData,
  IBookRequestSeatData,
  IBookRequestTermData,
} from "@/repositories/book/bookRepository.types";
import { BookIntervalCode } from "@/types";
import deviceHelper from "@/utils/deviceInfo";

export default function useGetDailyBookRequestParams(
  autoSeatAssign: boolean,
  seatsSelectable: boolean,
  turnId: string,
  getOnStationId: string,
  getOffStationId: string,
  data: IDateInfo[],
  isMonthlyBook: boolean
): IBookRequest {
  const parseSeat = (dateInfo: IDateInfo): IBookRequestSeatData => {
    if (seatsSelectable) {
      return {
        allocUid: dateInfo.bookableDate?.allocUid ?? "",
        seatNo: dateInfo.bookableDate?.mySeatNo ?? "",
      };
    } else {
      return {
        allocUid: dateInfo.bookableDate?.allocUid ?? "",
      };
    }
  };

  const parseTermData = (dateInfo: IDateInfo): IBookRequestTermData => {
    const seatData: IBookRequestSeatData = parseSeat(dateInfo);
    const term: IBookRequestTermData = {
      date: dateInfo.date,
      seats: [seatData],
    };
    return term;
  };

  const termsList: IBookRequestTermData[] = [];
  data.forEach((dateInfo) => {
    const term = parseTermData(dateInfo);
    termsList.push(term);
  });

  const lineData: IBookRequestLineData = {
    lineTurnUid: turnId,
    onStationUid: getOnStationId,
    offStationUid: getOffStationId,
    terms: termsList,
  };

  const frontPath = window.location.href.split("/");
  const bookRequest: IBookRequest = {
    protocol: deviceHelper.isMobile() ? "MOBILE" : "PC",
    autoAssignDupSeatYn: autoSeatAssign,
    bookIntervalCode: isMonthlyBook
      ? BookIntervalCode.MONTH
      : BookIntervalCode.DAY,
    lines: [lineData],
    cancelUrl: frontPath[frontPath.length - 1],
  };

  return bookRequest;
}
